import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import * as api_academic from "../../core/service/api_academic";
import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { StatsInvoice, StatsMutation, StatsProfil } from "../common/home/Stats";
import { setLoading } from "../../core/feature/config/configSlice";
import { getAllYear, getSchedule } from "../../core/service/api_academic";
import senin from "../../assets/images/icon_schedule/senin.svg";
import selasa from "../../assets/images/icon_schedule/selasa.svg";
import rabu from "../../assets/images/icon_schedule/rabu.svg";
import kamis from "../../assets/images/icon_schedule/kamis.svg";
import jumat from "../../assets/images/icon_schedule/jumat.svg";
import sabtu from "../../assets/images/icon_schedule/sabtu.svg";
import minggu from "../../assets/images/icon_schedule/minggu.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import {
  Autoplay,
  EffectCoverflow,
  Keyboard,
  Navigation,
  Pagination,
} from "swiper";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Jadwal } from "../common/Jadwal";
import { BackButton } from "../common/BackButton";
moment.locale("id");

const ScheduleWeb = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [accounts, setAccounts] = useState<any>([]);
  const [companyId, setCompanyId] = useState("");
  const [callerId, setCallerId] = useState("");
  const [hari, setHari] = useState([
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
  ]);
  const [hari1, setHari1] = useState([
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
  ]);
  const [hari2, setHari2] = useState(["FRIDAY", "SATURDAY", "SUNDAY"]);
  const [schedule, setSchedule] = useState<any>([]);
  const [scheduleMonday, setScheduleMonday] = useState<any>([]);
  const [scheduleTuesday, setScheduleTuesday] = useState<any>([]);
  const [scheduleWednesday, setScheduleWednesday] = useState<any>([]);
  const [scheduleThursday, setScheduleThursday] = useState<any>([]);
  const [scheduleFriday, setScheduleFriday] = useState<any>([]);
  const [scheduleSaturday, setScheduleSaturday] = useState<any>([]);
  const [scheduleSunday, setScheduleSunday] = useState<any>([]);
  const [lessonList, setLessonList] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(true);
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedDay, setSelectedDay] = useState(
    moment(moment().day()).format("dddd")
  );
  const [selectedLessonYear, setSelectedLessonYear] = useState(
    moment(moment().day()).format("yyyy")
  );
  const [selectedCallerId, setSelectedCallerId] = useState(
    user.accounts[0].callerIdentities.length > 0
      ? user.accounts[0].callerIdentities[0].callerId
      : ""
  );
  const [selectedCallerName, setSelectedCallerName] = useState(
    user.accounts[0].callerIdentities.length > 0
      ? user.accounts[0].callerIdentities[0].name
      : ""
  );
  const [halaman1, setHalaman1] = useState(true);
  const [halaman2, setHalaman2] = useState(false);
  const env = Config.BaseUrlDev;

  useEffect(() => {
    console.log(moment().format("dddd"), "chuakss");
    if (moment().format("dddd") === "Senin") {
      setHalaman1(true);
      setHalaman2(false);
    } else if (moment().format("dddd") === "Selasa") {
      setHalaman1(true);
      setHalaman2(false);
    } else if (moment().format("dddd") === "Rabu") {
      setHalaman1(true);
      setHalaman2(false);
    } else if (moment().format("dddd") === "Kamis") {
      setHalaman1(true);
      setHalaman2(false);
    } else if (moment().format("dddd") === "Jumat") {
      setHalaman1(false);
      setHalaman2(true);
    } else if (moment().format("dddd") === "Sabtu") {
      setHalaman1(false);
      setHalaman2(true);
    } else if (moment().format("dddd") === "Minggu") {
      setHalaman1(false);
      setHalaman2(true);
    }

    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getActiveYear();
      getAllAccounts();
    }
  }, [selectedCallerId, selectedDate]);
  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        getAllAccounts();
      });
    }
  }, [location.pathname.split("/")[2]]);

  function getAllAccounts() {
    let temp = user.accounts[0].callerIdentities;
    setAccounts(temp);
    getLessonList();
  }

  function getActiveYear() {
    api_academic.getAllYear().then((res: any) => {
      let selectedYear = "";
      res.data.map((item: any) => {
        if (item.defaultYear) {
          selectedYear = item.year;
        }
      });
      let dayname = moment(selectedDate)
        .locale("en")
        .format("dddd")
        .toLocaleUpperCase();
      getAllSchedule(selectedYear, selectedCallerId, dayname);
      setSelectedLessonYear(selectedYear);
    });
  }

  function getLessonList() {
    api_academic.getLessonList().then((res: any) => {
      let temp = res.data.content;

      setLessonList(temp);
    });
  }

  async function getAllSchedule(year: any, callerId: any, day: any) {
    dispatch(setLoading(true));

    hari.forEach((element) => {
      if (element === "SUNDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleSunday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));
            setScheduleSunday([]);
          });
      }
      if (element === "MONDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleMonday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleMonday([]);
          });
      }
      if (element === "TUESDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleTuesday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleTuesday([]);
            setIsEmpty(true);
          });
      }
      if (element === "WEDNESDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleWednesday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleWednesday([]);
          });
      }
      if (element === "THURSDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleThursday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleThursday([]);
          });
      }
      if (element === "FRIDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleFriday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleFriday([]);
          });
      }
      if (element === "SATURDAY") {
        api_academic
          .getSchedule(year, callerId, element)
          .then((res) => {
            dispatch(setLoading(false));

            setScheduleSaturday(res.data.content);
          })
          .catch((e) => {
            dispatch(setLoading(false));

            setScheduleFriday([]);
          });
      }
    });
  }

  function getLessonName(id: any) {
    let temp = "";
    lessonList.map((item: any) => {
      if (item._id == id) {
        temp = item.lessonName;
      }
    });
    return temp;
  }

  const gantiHalaman = () => {
    setHalaman1(false);
    setHalaman2(true);
  };

  return (
    <>
      <div className="font-montserrat">
        <StatsInvoice />
        <div className="bg-white relative container w-full border rounded-2xl z-50 -mt-40">
          <div className="grid grid-flow-col pr-4 z-20">
            <div className="flex py-4 ml-12">
              <BackButton />
              <div className="font-bold text-4xl">{t("SCHEDULE.title")}</div>
            </div>
            <select
              name=""
              id=""
              onChange={(item) => setSelectedCallerId(item.target.value)}
              className="w-full my-4 border bg-white rounded-xl py-2 px-3"
            >
              {accounts.map((item: any) => {
                return (
                  <option value={item.callerId} key={item.callerId}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className=" py-3 px-3 container-fluid h-auto mt-8 relative justify-center flex flex-row">
          {halaman1 === true ? (
            <div className="flex flex-row">
              {hari1.map((e: any, i: any) => (
                <div className="bg-white w-[22vw] rounded-xl mx-3 p-2">
                  <div className="w-full">
                    {/* <img
                      // src={
                      //   e === "MONDAY"
                      //     ? senin
                      //     : e === "TUESDAY"
                      //     ? selasa
                      //     : e === "WEDNESDAY"
                      //     ? rabu
                      //     : kamis
                      // }
                      alt=""
                    /> */}
                  </div>
                  <div className="py-2 rounded-lg">
                    {/* <div className={ `rounded-t-lg px-4 py-1 text-white ${funBg}`}> */}
                    <div
                      className={`rounded-t-lg text-[1vw] w-full px-4 py-1 text-white ${
                        e === "MONDAY"
                          ? "bg-mon"
                          : e === "TUESDAY"
                          ? "bg-tue"
                          : e === "WEDNESDAY"
                          ? "bg-wed"
                          : e === "THURSDAY"
                          ? "bg-thu"
                          : null
                      }`}
                    >
                      {e === "MONDAY"
                        ? t("SCHEDULE.day.mon")
                        : e === "TUESDAY"
                        ? t("SCHEDULE.day.tues")
                        : e === "WEDNESDAY"
                        ? t("SCHEDULE.day.wed")
                        : e === "THURSDAY"
                        ? t("SCHEDULE.day.thurs")
                        : null}
                    </div>

                    {e === "MONDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleMonday.length > 0 &&
                              scheduleMonday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleMonday.length > 0 &&
                              scheduleMonday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleMonday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : e === "TUESDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleTuesday.length > 0 &&
                              scheduleTuesday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleTuesday.length > 0 &&
                              scheduleTuesday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleTuesday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : e === "WEDNESDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleWednesday.length > 0 &&
                              scheduleWednesday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleWednesday.length > 0 &&
                              scheduleWednesday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleWednesday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : e === "THURSDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleThursday.length > 0 &&
                              scheduleThursday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleThursday.length > 0 &&
                              scheduleThursday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleThursday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : null}
                  </div>
                </div>
                // <SwiperSlide key={i}>
                //   <Jadwal
                //     year={selectedLessonYear}
                //     callerId={selectedCallerId}
                //     day={e}
                //     asset={
                //       e === "MONDAY"
                //         ? senin
                //         : e === "TUESDAY"
                //           ? selasa
                //           : e === "WEDNESDAY"
                //             ? rabu
                //             : e === "THURSDAY"
                //               ? kamis
                //               : e === "FRIDAY"
                //                 ? jumat
                //                 : e === "SATURDAY"
                //                   ? sabtu
                //                   : minggu
                //     }
                //     dayName={e}
                //     list={lessonList}
                //     jadwal={e === "MONDAY"
                //       ? scheduleMonday
                //       : e === "TUESDAY"
                //         ? scheduleTuesday
                //         : e === "WEDNESDAY"
                //           ? scheduleWednesday
                //           : e === "THURSDAY"
                //             ? scheduleThursday
                //             : e === "FRIDAY"
                //               ? scheduleFriday
                //               : e === "SATURDAY"
                //                 ? scheduleSaturday
                //                 : scheduleSunday}
                //     selectDay={
                //       e === "MONDAY"
                //         ? t("SCHEDULE.day.mon")
                //         : e === "TUESDAY"
                //           ? t("SCHEDULE.day.tues")
                //           : e === "WEDNESDAY"
                //             ? t("SCHEDULE.day.wed")
                //             : e === "THURSDAY"
                //               ? t("SCHEDULE.day.thurs")
                //               : e === "FRIDAY"
                //                 ? t("SCHEDULE.day.fri")
                //                 : e === "SATURDAY"
                //                   ? t("SCHEDULE.day.sat")
                //                   : t("SCHEDULE.day.sun")
                //     }
                //   />
                // </SwiperSlide>
              ))}
            </div>
          ) : halaman2 === true ? (
            <div className="flex flex-row">
              {hari2.map((e: any, i: any) => (
                <div className="bg-white w-[22vw] rounded-xl mx-3 p-2">
                  <div className="w-full">
                    {/* <img
                      src={
                        e === "FRIDAY"
                          ? jumat
                          : e === "SATURDAY"
                          ? sabtu
                          : minggu
                      }
                      alt=""
                    /> */}
                  </div>
                  <div className="py-2 rounded-lg">
                    {/* <div className={ `rounded-t-lg px-4 py-1 text-white ${funBg}`}> */}
                    <div
                      className={`rounded-t-lg text-[1vw] w-full px-4 py-1 text-white ${
                        e === "FRIDAY"
                          ? "bg-fri"
                          : e === "SATURDAY"
                          ? "bg-sat"
                          : "bg-sun"
                      }`}
                    >
                      {e === "FRIDAY"
                        ? t("SCHEDULE.day.fri")
                        : e === "SATURDAY"
                        ? t("SCHEDULE.day.sat")
                        : t("SCHEDULE.day.sun")}
                    </div>

                    {e === "FRIDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleFriday.length > 0 &&
                              scheduleFriday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleFriday.length > 0 &&
                              scheduleFriday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleFriday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : e === "SATURDAY" ? (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleSaturday.length > 0 &&
                              scheduleSaturday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleSaturday.length > 0 &&
                              scheduleSaturday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleSaturday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="flex flex-row bg-white py-1 border border-black">
                          <div className="w-2/5 text-center border-r text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.time")}
                            </div>
                            {scheduleSunday.length > 0 &&
                              scheduleSunday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center text-[0.8vw]">
                                    {" "}
                                    {String(item.startTime).substring(
                                      0,
                                      5
                                    )} - {String(item.endTime).substring(0, 5)}{" "}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="w-3/5 text-center text-[1vw]">
                            <div className="w-full border-b">
                              {t("SCHEDULE.lesson")}
                            </div>
                            {scheduleSunday.length > 0 &&
                              scheduleSunday[0].lessons.map((item: any) => {
                                return (
                                  <div className="mt-2 text-center flex justify-center align-center text-[0.8vw]">
                                    {getLessonName(item.lessonId)}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        {scheduleSunday.length === 0 && (
                          <div className="flex border justify-center align-center h-[10vh] font-montserrat text-[0.8vw] relative flex-row items-center bg-white">
                            {t("OTHER.dataNotFound")}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                // <SwiperSlide key={i}>
                //   <Jadwal
                //     year={selectedLessonYear}
                //     callerId={selectedCallerId}
                //     day={e}
                //     asset={
                //       e === "MONDAY"
                //         ? senin
                //         : e === "TUESDAY"
                //           ? selasa
                //           : e === "WEDNESDAY"
                //             ? rabu
                //             : e === "THURSDAY"
                //               ? kamis
                //               : e === "FRIDAY"
                //                 ? jumat
                //                 : e === "SATURDAY"
                //                   ? sabtu
                //                   : minggu
                //     }
                //     dayName={e}
                //     list={lessonList}
                //     jadwal={e === "MONDAY"
                //       ? scheduleMonday
                //       : e === "TUESDAY"
                //         ? scheduleTuesday
                //         : e === "WEDNESDAY"
                //           ? scheduleWednesday
                //           : e === "THURSDAY"
                //             ? scheduleThursday
                //             : e === "FRIDAY"
                //               ? scheduleFriday
                //               : e === "SATURDAY"
                //                 ? scheduleSaturday
                //                 : scheduleSunday}
                //     selectDay={
                //       e === "MONDAY"
                //         ? t("SCHEDULE.day.mon")
                //         : e === "TUESDAY"
                //           ? t("SCHEDULE.day.tues")
                //           : e === "WEDNESDAY"
                //             ? t("SCHEDULE.day.wed")
                //             : e === "THURSDAY"
                //               ? t("SCHEDULE.day.thurs")
                //               : e === "FRIDAY"
                //                 ? t("SCHEDULE.day.fri")
                //                 : e === "SATURDAY"
                //                   ? t("SCHEDULE.day.sat")
                //                   : t("SCHEDULE.day.sun")
                //     }
                //   />
                // </SwiperSlide>
              ))}
            </div>
          ) : null}
        </div>
        <div className="flex w-full justify-center mb-2 mt-5">
          <button
            disabled={halaman1 === true}
            onClick={() => setHalaman1(true)}
            className="swiper-button-prev disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
          >
            Previous
          </button>
          <button
            disabled={halaman1 === false}
            onClick={() => gantiHalaman()}
            className="swiper-button-next disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default ScheduleWeb;
